import {css} from 'lit';
export const styles = css`:host {
  --border: var(--gray-700);
  --background: transparent;
  --border-secondary: var(--primary-500);
  --background-secondary: var(--primary-500);
  --size: 12px;
  --border-size: 1px;
}

div {
  display: inline-flex;
  align-items: center;
  color: var(--dark-text-secondary);
}

div::before {
  content: '';
  display: inline-block;
  width: var(--size);
  height: var(--size);
  border: var(--border-size) solid var(--border);
  background-color: var(--background);
  border-radius: 50%;
}

div span {
  display: inline-block;
  margin-left: 4px;
  font-size: 14px;
}

div.active::before {
  border-color: green;
  border-color: var(--border-secondary, green);
  background-color: green;
  background-color: var(--background-secondary, green);
}
`;
export default styles;
